import {Component, OnDestroy, ViewChild} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {DartAPIService} from "./dart.service";
import {SuccessComponent} from "../errors/success.component";
import {handleErrors} from "../misc/handle-errors.decorator";
import {toggleLoading} from "../misc/loading.decorator";
import {DAAS_TARGET_SYSTEMS, TARGET_SYSTEM} from "../helpers/app-constants";
import {AppSettingsService} from "../app-settings/app-settings.service";
import {DartDealImportWarningComponent} from "./dartDealImport-warning.component";
import {WorkflowService} from "../../src/workflow/workflow.service";
import {Subscription} from "rxjs";

export type DartDealImportDialogModel = {
  projectId: string;
  targetSystem: string;
  CPQSource: boolean;
};

@Component({
  templateUrl: "./dartDealImport-dialog.template.pug",
  providers: [DartAPIService],
})
export class DartDealImportDialogComponent extends DialogComponent<DartDealImportDialogModel, boolean>
  implements DartDealImportDialogModel, OnDestroy {
  @ViewChild(SuccessComponent)
  public successComponent;

  public projectId: string;
  public targetSystem: string;
  public CPQSource: boolean = false;
  public displayTargetSystem: boolean = false;
  public error: Error;
  public processing: boolean = false;
  public dartDealKey: string = "";
  por373: boolean = false;
  por633: boolean;
  continueToImport: boolean = false;
  private dialogServiceSubscription: Subscription;

  constructor(
    public dialogService: DialogService,
    public dartApiService: DartAPIService,
    public workflowService: WorkflowService,
    private appSettingsService: AppSettingsService,
  ) {
    super(dialogService);
    this.result = false;
  }

  async ready() {
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;
    this.displayTargetSystem = (!this.targetSystem);
    let por373_flag = false, por373_Tmc = false;
    let por633_flag = false, por633_Tmc = false;
    const featurePermissions = await this.appSettingsService.getFeaturePermissionsList(["POR373", "POR373_TMC", "POR633", "POR633_TMC"]);
    
    [por373_flag, por373_Tmc, por633_flag, por633_Tmc] = [
      featurePermissions["POR373"],
      featurePermissions["POR373_TMC"],
      featurePermissions["POR633"],
      featurePermissions["POR633_TMC"]
    ];
    this.por373 = por373_flag || por373_Tmc;
    this.por633 = por633_flag || por633_Tmc;
    this.dialogServiceSubscription = this.dialogService.continueToImport.subscribe((value) => {
      if (value.continueToImport === true && value.continueToImportTemplate === false) {
        this.continueToImport = true;
        this.importDealKey();
        this.result = true;
      }
    });
  }

  @toggleLoading("processing")
  @handleErrors()
  async importDealKey() {
    let dartResponse;
    this.processing = true;
    this.result = false;
    this.successComponent.closeAll();
    const source = this.CPQSource ? "CPQ" : "DAAS";
    if (!this.targetSystem) throw new Error("Target System is required");
    if(this.por373 && DAAS_TARGET_SYSTEMS.includes(this.targetSystem)){
      dartResponse = await this.dartApiService.importDaasDartDealById(this.dartDealKey, this.projectId, this.targetSystem, source);
    }
    else if (this.targetSystem === TARGET_SYSTEM.DAAS || this.targetSystem === TARGET_SYSTEM.MIGRATION_DAAS) {
      dartResponse = await this.dartApiService.importDaasDartDealById(this.dartDealKey, this.projectId, undefined, source);
    } else if (this.continueToImport === true) {
      dartResponse = await this.dartApiService
        .importDartDealById(this.dartDealKey, this.targetSystem, this.projectId, this.continueToImport);
    } else {
      dartResponse = await this.dartApiService.importDartDealById(this.dartDealKey, this.targetSystem, this.projectId);
    }
    if (dartResponse.withoutNetPriceSolutionIdsDartDealNumber && dartResponse.withoutNetPriceSolutionIdsDartDealNumber.dartDeal.length > 0 &&
          this.por633 && this.continueToImport === false) {
      this.dialogService.showDialog(DartDealImportWarningComponent, {
        withoutNetPriceSolutionIdsDartDealNumber: dartResponse.withoutNetPriceSolutionIdsDartDealNumber,
        template: false,
      });
    } else {
      this.successComponent.showSuccessMessage(`${this.CPQSource?'Deal(s) imported from SAP CPQ':'DART Deal(s) imported'}.`);
    }
    this.result = true;
  }

  ngOnDestroy(): void {
    this.dialogServiceSubscription.unsubscribe();
    super.ngOnDestroy();
  }
}
